import type { RouterContextType } from "@/api/permissions/permissions.api";
import { VisitFormPreviewPage } from "@/components/features/WorkOrders/VisitDetail/VisitFormPage/VisitFormPreviewPage";
import { authGuardWithPermissions } from "@/utils/authGuard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/work-orders/$workOrderId/$visitId/form-preview/")({
  component: VisitFormPreview,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function VisitFormPreview() {
  const { visitId, workOrderId } = Route.useParams();
  return <VisitFormPreviewPage visitId={visitId} workOrderId={workOrderId} />;
}
